import { Text, Tooltip, Stack } from '@customerio/pluma-components/react';
import {
  getQualityIndicator,
  getInverseQualityIndicator,
  getQualityColor,
  getQualityMessage,
} from '../utils/quality-indicators';
import { formatPercent, formatNumber } from '@/utils/number-format';

type MetricName = 'deliveryRate' | 'bounceRate' | 'spamRate' | 'openRate' | 'clickRate';

interface MetricCellProps {
  percent: number;
  count: number;
  metricName: MetricName;
  isInverse?: boolean;
}

export function MetricCell({ percent, count, metricName, isInverse = false }: MetricCellProps) {
  const quality = isInverse
    ? getInverseQualityIndicator(metricName, percent)
    : getQualityIndicator(metricName, percent);
  const color = getQualityColor(quality);
  const precision = metricName === 'spamRate' ? 2 : 1;

  const message = getQualityMessage(metricName, quality, isInverse, precision);

  const formattedPercent = formatPercent(percent, precision);
  const formattedCount = formatNumber(count);

  const content = (
    <Stack cursor={message != null ? 'help' : undefined}>
      <Text color={color}>{formattedPercent}</Text>
      <Text color="subtle" size="xs">
        {formattedCount}
      </Text>
    </Stack>
  );

  if (message == null) {
    return content;
  }

  return (
    <Tooltip placement="right" content={message}>
      {content}
    </Tooltip>
  );
}
